"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _isArray = _interopRequireDefault(require("lodash/isArray"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var readStorage = function readStorage(localStorageKey) {
  var storage = localStorage[localStorageKey];
  if (storage) {
    try {
      var current = JSON.parse(localStorage[localStorageKey]);
      if ((0, _isArray.default)(current)) {
        return current;
      } else {
        return [];
      }
    } catch (error) {
      return [];
    }
  } else {
    return [];
  }
};
var _default = readStorage;
exports.default = _default;